import React from 'react'
import styled from 'styled-components'

const Img = styled.img `
  width: 100%;
  max-width: 100%;
  display: inline-block;
`

const Image = ({ src, extension = 'jpg', alt = '' }) => (
  <Img
    srcSet={ `${src}.${extension}, ${src}@2x.${extension} 2x` }
    src={ `${src}.${extension}` }
    alt={ alt }
  />
)

export { Image }
